import type { Searches } from '~/types';

export default function getReportImageUuid(
  search: Searches.StoredSearchObject
): string {
  for (const key of ['all', 'any', 'none'] as Array<
    keyof Searches.StoredSearchObject
  >) {
    for (const item of search[key]) {
      if (item.type === 'report') {
        return item.value;
      }
    }
  }
  return '0';
}
